import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import {
  GlgTableRow,
  GlgTableCell,
  GlgTooltip,
} from 'SharedComponents'

const MembershipProgramsTableRow = ({ ...props }) => {
  let renewalDate = ''
  let renewalDateCell
  if (props.hasRenewals) {
    if (props.renewal_date) {
      if (props.isExpired) {
        renewalDate = (
          <GlgTooltip tooltip={ !window.I18n ? '' : window.I18n.t('player_activity.registration.membership.membership_expired') }>
            <span className='exipration-date'>
              { props.renewal_date }
            </span>
          </GlgTooltip>
        )
      } else {
        renewalDate = props.renewal_date 
      }
    }
    renewalDateCell = (
      <GlgTableCell>
        { renewalDate }
      </GlgTableCell>
    )
  }

  return (
    <GlgTableRow { ...props } isSortable={ false }>
      <GlgTableCell>
        <GlgTooltip tooltip={ props.name }>
          <span>
            { _.truncate(props.name, { length: 40 }) }
          </span>
        </GlgTooltip>
      </GlgTableCell>
      <GlgTableCell>
        { props.join_date }
      </GlgTableCell>
      { renewalDateCell }
    </GlgTableRow>
  )
}

MembershipProgramsTableRow.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  join_date: PropTypes.string.isRequired,
  renewal_date: PropTypes.string,
  isExpired: PropTypes.bool.isRequired,
  hasRenewals: PropTypes.bool,
}

export default MembershipProgramsTableRow
